document.addEventListener("DOMContentLoaded", code);

if (window.acf) {
  window.acf.addAction('render_block_preview/type=counter', code);
}

var settings = false;
var counter_visible = false;

function code(event) {
  var timer = false;
  var counter_container = document.getElementsByClassName('counter');

  if (counter_container.length > 0) {
    if (!settings) {
      var xhttp = new XMLHttpRequest();

      xhttp.onreadystatechange = function () {
        if (this.status === 200 && !settings) {
          try {
            settings = JSON.parse(xhttp.responseText);

            for (var i = 0; i < counter_container.length; i++) {
              counter_container[i].setAttribute('data-next', settings['next']);
            }

            code();
          } catch (error) {
            settings = false;
          }
        }
      };

      xhttp.open("GET", counter_container[0].getAttribute('data-endpoint'), true);
      xhttp.send();
    } else {
      var _loop = function _loop(i) {
        var gap = 86400 / settings['daily'];
        var exec = gap * 1000;

        function run_counter() {
          var initialize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          //refresh container fetch
          counter_container = document.getElementsByClassName('counter'); //if the counter is on screen

          if (counter_visible || !counter_visible && is_visible(counter_container[i])) {
            var next = counter_container[i].getAttribute('data-next');
            var counters = counter_container[i].getElementsByClassName('counter-value');
            var delay = 0;

            if (initialize) {
              counter_container[i].classList.add('initializing');
              delay = 1000;
              var defaults = (settings['current'] + '').split('').reverse();

              for (var ii = 0; ii < counters.length; ii++) {
                counters[ii].setAttribute('data-current', defaults[ii]);
              }

              setTimeout(function () {
                counter_container[i].classList.add('initialized');
                counter_visible = true;
              }, delay + 1100);
            }

            if (counters) {
              setTimeout(function () {
                var values = next.split('').reverse();

                var _loop2 = function _loop2(_ii) {
                  if (counters[_ii].getAttribute('data-current') != values[_ii]) {
                    counters[_ii].classList.add('moving');

                    setTimeout(function () {
                      counters[_ii].setAttribute('data-current', values[_ii]);

                      counters[_ii].classList.remove('moving');
                    }, exec - 50);
                  }
                };

                for (var _ii = 0; _ii < counters.length; _ii++) {
                  _loop2(_ii);
                }

                next = next.replace(next, format_counter_field(parseInt(next) + 1));
                counter_container[i].setAttribute('data-next', next);

                if (!timer) {
                  timer = setInterval(run_counter, exec);
                }
              }, delay);
            }
          } else {
            //run in 500ms
            setTimeout(function () {
              //attempt to run again with the same initialized parameter
              run_counter(initialize);
            }, 300);
          }
        }

        ;

        function format_counter_field(int) {
          int = int + '';

          if (int.length == 8) {
            int = '0' + int;
          } else if (int.length == 7) {
            int = '00' + int;
          }

          return int;
        }

        function is_visible(elem) {
          var bounding = elem.getBoundingClientRect();
          return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
        }

        ;
        run_counter(true);
      };

      for (var i = 0; i < counter_container.length; i++) {
        _loop(i);
      }
    }
  }
}